document.addEventListener(
  "DOMContentLoaded", () => {


    $(".menu-item-has-children").each(function(){
      $(this).children().first().replaceWith("<span>"+$(this).children().first().text()+"</span>");
    });

    if($(window).width() < 	1024){
      var MENU = new Mmenu( "#my-menu", {
        extensions: ["position-front"],
        navbar: {
          add: false,
        },
        navbars: [{
          "position": "top",
          // "content": [
          //   "<div class='menu_logo'></div>",
          // ]
        }],
        "slidingSubmenus": true,
      } , {
        // offCanvas: {
        //   clone: true,
        //   page: {
        //     selector: "#app",
        //   },
        // }
      });

      $('.mm-listitem a').on('click touch', function() {
        MENU.close();
      });

    }
  }
);

